import React from 'react';
import styled from 'styled-components';

const SHeader = styled.h2`
    font-weight: 700;
    font-size: 36px;
    letter-spacing: 0.01em;
    margin-bottom: 24px;
`;

interface Props {
    text: string;
}

export const Header = ({ text }: Props) => {
    return <SHeader>{text}</SHeader>;
};
